export const getDefaultInfinitePageParam = (page = 0, itemCount = 15) => ({
  page,
  itemCount,
});
